import { render, staticRenderFns } from "./DispenseConsumable.vue?vue&type=template&id=64733b80&scoped=true"
import script from "./DispenseConsumable.vue?vue&type=script&lang=js"
export * from "./DispenseConsumable.vue?vue&type=script&lang=js"
import style0 from "./DispenseConsumable.vue?vue&type=style&index=0&id=64733b80&prod&scoped=true&lang=css"
import style1 from "./DispenseConsumable.vue?vue&type=style&index=1&id=64733b80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64733b80",
  null
  
)

export default component.exports